import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtHelperService, JwtModule } from '@auth0/angular-jwt';

import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { CopyleaksReportModule } from './client/projects/plagiarism-report/src/lib/plagiarism-report/copyleaks-report.module';
import { NgxPrintModule } from 'ngx-print';
import { JwtInterceptor } from './app/rest-interceptor';

if (environment.production) {
  enableProdMode();
}

// Using async IIFE pattern for browser compatibility
// Top-level await is not supported by Angular's configured browser targets
// This is the recommended approach per Angular and TypeScript best practices
(async () => {
  await bootstrapApplication(AppComponent, {
    providers: [
      provideRouter(routes),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      importProvidersFrom(
        CopyleaksReportModule,
        JwtModule,
        NgxPrintModule
      ),
      { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
      JwtHelperService,
      { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    ]
  }).catch(err => console.error(err));
})();
